import React, { forwardRef } from 'react';

import type { UpperClothingColorsNullableParameter, SleeveLengthsNullableParameter } from '@vlabs/api/luna-api/model';
import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';

import { ColorGridFilter } from '@vlabs/monokit/shared/ui/color-grid-filter';
import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFiltersTranslation } from '../../i18n';
import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

function UpperAttributesFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { t } = useEventListFiltersTranslation();
  const { filters, updateFilters } = useEventListFilters();

  const selectedColors = filters.upper_clothing_colors ?? [];
  const selectedSleeves = filters.sleeve_lengths ?? [];

  const reset = () => updateFilters({
    upper_clothing_colors: undefined,
    sleeve_lengths: undefined,
  });

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={
        filters.upper_clothing_colors === undefined
        && filters.sleeve_lengths === undefined
      }
      onClickReset={reset}
      ref={ref}
    >
      <ColorGridFilter
        label={t('upper_clothing_colors')}
        onChange={(value) => updateFilters({
          upper_clothing_colors: value.length > 0
            ? (value as unknown as UpperClothingColorsNullableParameter)
            : undefined,
        })}
        options={EVENT_ENUMS.UPPER_BODY.UPPER_CLOSING_COLOR.raw}
        value={selectedColors as unknown as string[]}
      />

      <div className={st.Divider} />
      <div className={st.Subtitle}>{t('sleeve_lengths')}</div>
      <div className={st.CheckboxContainer}>
        <OptionsFilter
          isSearchable={false}
          name="sleeve_lengths"
          onChange={(value) => updateFilters({
            sleeve_lengths: value.length > 0
              ? (value as unknown as SleeveLengthsNullableParameter)
              : undefined,
          })}
          options={EVENT_ENUMS.UPPER_BODY.SLEEVE.raw}
          value={selectedSleeves}
        />
      </div>
    </PopoverWithButton>
  );
}

const UpperAttributesFilterPopoverWithRef = forwardRef(UpperAttributesFilterPopover);
export { UpperAttributesFilterPopoverWithRef as UpperAttributesFilterPopover };
